import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Snackbar from '@material-ui/core/Snackbar';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import styles from './styles';
import { recommendationData } from './recommendation';
import copyIcon from './copy.svg';

const responsiveStyles = theme => ({
  mobileDropdownHeader: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '15px',
      fontWeight: 'bold',
      color: '#0F145C',
      marginBottom: '5px',
      padding: 0,
    },
  },
  mobileResultContainer: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      maxWidth: '100%',
      minWidth: 'auto',
      padding: 0,
      alignItems: 'center',
    },
  },
  tabletResultContainer: {
    [theme.breakpoints.between('sm', 'md')]: {
      width: '100%',
      maxWidth: '100%',
      minWidth: 'auto',
      padding: 0,
      alignItems: 'center',
    },
  },
  mobileStepBoxContainer: {
    [theme.breakpoints.down('sm')]: {
      width: 'auto',
      maxWidth: '100%',
      minWidth: 'auto',
      padding: '16px',
      margin: '20px 10px 20px 10px',
      fontSize: '22px',
    },
  },
  tabletStepBoxContainer: {
    [theme.breakpoints.between('sm', 'md')]: {
      width: 'auto',
      maxWidth: '100%',
      minWidth: 'auto',
      padding: '18px',
      margin: '20px',
      fontSize: '22px',
    },
  },
  mobileStepBoxFullWidthContainer: {
    [theme.breakpoints.down('sm')]: {
      width: '96%',
      maxWidth: '100%',
      minWidth: 'auto',
      padding: '20px',
      margin: '20px 10px 20px 10px',
      backgroundColor: '#fff',
      borderRadius: 0,
      boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
      marginBottom: 40,
      overflowWrap: 'break-word',
    },
  },
  tabletStepBoxFullWidthContainer: {
    [theme.breakpoints.between('sm', 'md')]: {
      width: '96%',
      maxWidth: '100%',
      minWidth: 'auto',
      padding: '28px',
      margin: '20px',
      backgroundColor: '#fff',
      borderRadius: 0,
      boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
      marginBottom: 40,
      overflowWrap: 'break-word',
    },
  },
  mobileSelectionWrapper: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      maxWidth: '100%',
      minWidth: 'auto',
      margin: 0,
    },
  },
  tabletSelectionWrapper: {
    [theme.breakpoints.between('sm', 'md')]: {
      width: '100%',
      maxWidth: '100%',
      minWidth: 'auto',
      margin: 0,
    },
  },
  mobileStartControlsRow: {
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      padding: '0 16px',
      gap: '0',
    },
  },
  tabletStartControlsRow: {
    [theme.breakpoints.between('sm', 'md')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      padding: '0 24px',
      gap: '0',
    },
  },
  mobileDropdownWrapper: {
    [theme.breakpoints.down('sm')]: {
      minWidth: '100%',
      maxWidth: '100%',
      width: '100%',
      margin: '0 0 20px 0',
    },
  },
  tabletDropdownWrapper: {
    [theme.breakpoints.between('sm', 'md')]: {
      minWidth: '100%',
      maxWidth: '100%',
      width: '100%',
      margin: '0 0 20px 0',
    },
  },
  mobileResultFormControl: {
    [theme.breakpoints.down('sm')]: {
      minWidth: '100% !important',
      maxWidth: '100% !important',
      width: '100% !important',
      boxSizing: 'border-box',
    },
  },
  tabletResultFormControl: {
    [theme.breakpoints.between('sm', 'md')]: {
      minWidth: '100% !important',
      maxWidth: '100% !important',
      width: '100% !important',
      boxSizing: 'border-box',
    },
  },
  mobileEdgeDiv: {
    [theme.breakpoints.down('sm')]: {
      minWidth: '100%',
      maxWidth: '100%',
      marginRight: 0,
    },
  },
  tabletEdgeDiv: {
    [theme.breakpoints.between('sm', 'md')]: {
      minWidth: '100%',
      maxWidth: '100%',
      marginRight: 0,
    },
  },
  mobilePanelsOuter: {
    [theme.breakpoints.down('sm')]: {
      width: '96%',
    },
  },
  tabletPanelsOuter: {
    [theme.breakpoints.between('sm', 'md')]: {
      width: '96%',
    },
  },
});

const customStyles = theme => ({
  mobileScrollableTable: {
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      maxWidth: '100%',
      minWidth: 'auto',
    },
    [theme.breakpoints.down('sm')]: {
      '& table thead th, & table tbody td': {
        whiteSpace: 'normal',
        wordBreak: 'normal',
        overflowWrap: 'break-word',
      },
    },
  },
  mobileDevicesSummaryContainer: {
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      maxWidth: '100%',
      minWidth: 'auto',
      margin: '20px 0 0 0',
    },
  },
  mobileControlsRowStrip: {
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      maxWidth: '100%',
      minWidth: 'auto',
    },
  },
  mobileExpansionPanel: {
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      maxWidth: '100%',
      minWidth: 'auto',
      marginBottom: '20px',
    },
  },
  mobilePrintButton: {
    [theme.breakpoints.down('lg')]: {
      width: '11%',
      alignSelf: 'center',
      marginTop: '20px',
      marginBottom: '80px',
    },
  },
  panelsOuter: {
    width: '100%',
    '@media print': {
      width: '100% !important',
    },
  },
});

const mergedStyles = theme => ({
  ...styles(theme),
  ...customStyles(theme),
  ...responsiveStyles(theme),
});

const CustomTableCell = withStyles(theme => ({
  head: {
    fontWeight: 'bold',
    backgroundColor: '#fff',
    color: '#000',
    textAlign: 'center',
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
    whiteSpace: 'normal',
    '@media print': {
      fontSize: 14,
      padding: '4px 8px',
      boxSizing: 'border-box',
    },
  },
  body: {
    fontSize: 14,
    backgroundColor: '#fff',
    color: '#000',
    textAlign: 'center',
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
    whiteSpace: 'normal',
    '@media print': {
      fontSize: 14,
      padding: '4px 8px',
      boxSizing: 'border-box',
    },
  },
}))(TableCell);

class Result extends Component {
  constructor() {
    super();
    this.state = {
      expanded: '',
      showPrintModal: false,
      printOverview: true,
      printLTP: true,
      printRec: true,
      showCopyNotification: false,
      isMobile: window.innerWidth <= 600,
      isTablet: window.innerWidth > 600 && window.innerWidth <= 1280,
    };
  }

  componentWillMount() {
    this.getSessionID();
  }

  componentDidMount() {
    this.setState({ expanded: 'panel1' });
    this.props.changeActiveStep(2);
    window.addEventListener('resize', this.handleResize);

    if (this.props.updateShareableLink) {
      this.props.updateShareableLink();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  componentDidUpdate(prevProps) {
    const devicesChanged =
      JSON.stringify(prevProps.getSelectedDevices) !==
      JSON.stringify(this.props.getSelectedDevices);

    if (
      prevProps.selectedTime !== this.props.selectedTime ||
      devicesChanged ||
      prevProps.server !== this.props.server ||
      prevProps.client !== this.props.client ||
      prevProps.session !== this.props.session
    ) {
      if (this.props.updateShareableLink) {
        this.props.updateShareableLink();
      }
    }
  }

  handleResize = () => {
    const width = window.innerWidth;
    const isMobile = width <= 600;
    const isTablet = width > 600 && width <= 1280;
    if (isMobile !== this.state.isMobile || isTablet !== this.state.isTablet) {
      this.setState({ isMobile, isTablet });
    }
  };

  getSessionID = () => {
    const sessionID = this.props.match.url.substr(1);
    this.props.getSessionID(sessionID);
  }

  getArchiveTime = () => {
    if (this.props.time.length !== 0) {
      return this.props.time.map(arch => (
        <MenuItem
          id="archiveTime"
          className={this.props.classes.resultMenuItem}
          key={arch.id}
          value={arch.value}
        >
          {arch.text}
        </MenuItem>
      ));
    }
    return "";
  }

  getArchiveTimeForEDGE = () => {
    if (this.props.time.length !== 0) {
      return this.props.time.map(arch => (
        <option
          id="archiveTime"
          className={this.props.classes.resultMenuItem}
          key={arch.id}
          value={arch.value}
        >
          {arch.text}
        </option>
      ));
    }
    return "";
  }

  updateSelectTime = (event) => {
    this.props.changeTime(event.target.value);
  }

  getOverviewInformation = (period, identifier) => {
    if (this.props.getSelectedDevices.length !== 0) {
      let total;

      if (identifier === "studies") {
        total = this.props.getSelectedDevices
          .map(dev => Number(dev.studies_per_day))
          .reduce((acc, cur) => acc + cur, 0);
      } else if (identifier === "storage") {
        total = this.props.getSelectedDevices
          .map(dev => Number(dev.studies_per_day) * 73.66)
          .reduce((acc, cur) => acc + cur, 0);
      } else {
        total = 0;
      }

      if (total > 0) {
        if (identifier === "studies") {
          switch (period) {
            case "day": return total;
            case "month": return Math.ceil(total * 365 / 12);
            case "year": return total * 365;
            default: return "error";
          }
        } else if (identifier === "storage") {
          const dailyStorageGB = total / 1024;
          switch (period) {
            case "day": return Math.round(dailyStorageGB);
            case "month": return Math.round(dailyStorageGB * 30.21875);
            case "year": return Math.round(dailyStorageGB * 362.28125);
            default: return "error";
          }
        }
      }
      return 0;
    }
    return 0;
  }

  getRecommendation = (recommendationKey) => {
    const recommendation = recommendationData[recommendationKey];
    if (recommendation) {
      return (
        <div style={{ overflowWrap: 'break-word', lineHeight: '1.8em', textAlign: 'left', wordBreak: 'break-word', whiteSpace: 'normal' }}>
          <div><strong>Title:</strong> {recommendation.name}</div>
          <div><strong>CPU:</strong> {recommendation.cpu}</div>
          <div><strong>RAM:</strong> {recommendation.ram}</div>
          <div><strong>HDD/SSD:</strong> {recommendation.hdd}</div>
          <div><strong>NIC:</strong> {recommendation.nic}</div>
          <div><strong>OS:</strong> {recommendation.os}</div>
        </div>
      );
    }
    return <div>No recommendation available</div>;
  }

  getDevicesSummaryRows = () => {
    const devices = this.props.getSelectedDevices;
    if (!devices || devices.length === 0) {
      return (
        <TableRow>
          <CustomTableCell colSpan={4}>No devices added</CustomTableCell>
        </TableRow>
      );
    }

    const groups = {};
    devices.forEach(device => {
      const key = `${device.name}-${device.studies_per_day}-${device.size_per_study}`;
      if (!groups[key]) {
        groups[key] = {
          count: 0,
          name: device.name,
          studies_per_day: device.studies_per_day,
          size_per_study: device.size_per_study
        };
      }
      groups[key].count++;
    });

    return Object.values(groups).map((group, index) => (
      <TableRow key={index}>
        <CustomTableCell>{group.name}</CustomTableCell>
        <CustomTableCell numeric>{group.count}</CustomTableCell>
        <CustomTableCell numeric>{group.studies_per_day}</CustomTableCell>
        <CustomTableCell numeric>{group.size_per_study}</CustomTableCell>
      </TableRow>
    ));
  }

  calculateTotalStorage = () => {
    if (this.props.getSelectedDevices.length !== 0) {
      const totalStudies = this.props.getSelectedDevices
        .map(dev => Number(dev.studies_per_day))
        .reduce((acc, cur) => acc + cur, 0);

      const totalStorageMB = totalStudies * 73.66 * 365 * parseInt(this.props.selectedTime, 10);
      return (totalStorageMB / (1024 * 1024)).toFixed(2);
    }
    return '0';
  }

  generateLongTermProjections = () => {
    const years = parseInt(this.props.selectedTime, 10);
    const projections = [];

    const totalStudies = this.props.getSelectedDevices.reduce((acc, device) => acc + Number(device.studies_per_day), 0);
    const dailyDICOMGB = (totalStudies * 73.66) / 1024;
    const dailyDBGB = this.props.getSelectedDevices.reduce((acc, device) => acc + ((device.studies_per_day * 0.1) / 1024), 0);

    let cumulativeDICOMGB = 0;
    let cumulativeDBGB = 0;

    for (let year = 1; year <= years; year++) {
      let daysDICOM = (year <= 2) ? 384 : (year % 2 === 1 ? 352 : 384);
      cumulativeDICOMGB += dailyDICOMGB * daysDICOM;
      const dicomTB = Math.round(cumulativeDICOMGB / 1024);

      let daysDB = (year <= 2) ? 373 : (year === 3 ? 349 : 372);
      const additionalDB = Math.floor(dailyDBGB * daysDB);
      cumulativeDBGB += additionalDB;

      projections.push({ year, dicomTB, dbGB: cumulativeDBGB });
    }

    return projections;
  }

  handleChange = panel => (event, expanded) => {
    if (this.state.expanded === 'all') return;
    this.setState({ expanded: expanded ? panel : false });
  };

  copyToClipboard = () => {
    const element = document.getElementById("textfieldLink");
    if (element) {
      element.select();
      document.execCommand('copy');
      this.setState({ showCopyNotification: true });
      setTimeout(() => {
        this.setState({ showCopyNotification: false });
      }, 2000);
    }
  }

  disableChanging = (sessionLink) => {
    const input = document.getElementById("link");
    if (input) {
      input.value = sessionLink;
    }
  }

  printPage = () => {
    this.setState({ showPrintModal: true, printOverview: true, printLTP: true, printRec: true });
  }

  confirmPrint = () => {
    this.setState(
      { expanded: 'all', showPrintModal: false },
      () => {
        setTimeout(() => {
          window.print();
          this.setState({ expanded: 'panel1', printOverview: true, printLTP: true, printRec: true });
        }, 500);
      }
    );
  }

  closePrintModal = () => {
    this.setState({ showPrintModal: false, expanded: 'panel1', printOverview: true, printLTP: true, printRec: true });
  }

  render() {
    const { classes } = this.props;
    const { expanded, showPrintModal, printOverview, printLTP, printRec, isMobile, isTablet } = this.state;

    const sessionLink = this.props.shareableLink;
    const resultLink = sessionLink || 'https://pacscalculator.com/#/result/';

    const resultContainerClass = [
      classes.resultContainer,
      isMobile && classes.mobileResultContainer,
      isTablet && classes.tabletResultContainer,
    ].filter(Boolean).join(' ');

    const stepBoxClass = [
      classes.stepBoxContainer,
      isMobile && classes.mobileStepBoxContainer,
      isTablet && classes.tabletStepBoxContainer,
      isMobile && classes.mobileStepBoxFullWidthContainer,
      isTablet && classes.tabletStepBoxFullWidthContainer,
    ].filter(Boolean).join(' ');

    const selectionWrapperClass = [
      classes.selectionWrapper,
      isMobile && classes.mobileSelectionWrapper,
      isTablet && classes.tabletSelectionWrapper,
    ].filter(Boolean).join(' ');

    const startControlsRowClass = [
      classes.startControlsRow,
      isMobile && classes.mobileStartControlsRow,
      isTablet && classes.tabletStartControlsRow,
    ].filter(Boolean).join(' ');

    const dropdownWrapperClass = [
      classes.dropdownWrapper,
      isMobile && classes.mobileDropdownWrapper,
      isTablet && classes.tabletDropdownWrapper,
    ].filter(Boolean).join(' ');

    const resultFormControlClass = [
      classes.resultFormControl,
      classes.hideInternalLabel,
      classes.resultFormControlNoMB,
      isMobile && classes.mobileResultFormControl,
      isTablet && classes.tabletResultFormControl,
    ].filter(Boolean).join(' ');

    const edgeDivClass = [
      classes.edgeDiv,
      classes.hideInternalLabel,
      isMobile && classes.mobileEdgeDiv,
      isTablet && classes.tabletEdgeDiv,
    ].filter(Boolean).join(' ');

    const expansionPanelBase = [
      classes.resultExpansionPanel,
      classes.mobileExpansionPanel,
    ].filter(Boolean).join(' ');

    const panelsOuterClass = [
      classes.panelsOuter,
      isMobile && classes.mobilePanelsOuter,
      isTablet && classes.tabletPanelsOuter,
    ].filter(Boolean).join(' ');

    const stepBoxTextStyle = isMobile
      ? { margin: 0, fontSize: '16px', color: '#0F145C' }
      : { margin: 0, fontSize: '24px', color: '#0F145C' };

    const dropdownHeaderStyle = isMobile
      ? { fontSize: '15px', fontWeight: 'bold', color: '#0F145C', marginBottom: '5px', padding: 0 }
      : {};

    return (
      <Grid
        container
        className={resultContainerClass}
        id="resultContainer"
        spacing={0}
        direction="column"
        justify="space-around"
        alignItems="center"
        item
      >
        <Grid container direction="row" className={stepBoxClass + " stepBoxPrintHide"}>
          <p style={stepBoxTextStyle}>
            <strong>Step&nbsp;4:</strong> Choose the archive period and generate your own link.
          </p>
        </Grid>

        <Grid container className={selectionWrapperClass}>
          <div className={startControlsRowClass}>
            {this.props.isEDGE ? (
              <div className={dropdownWrapperClass}>
                <Typography className={classes.dropdownHeader} style={dropdownHeaderStyle}>Archive Period</Typography>
                <div className={edgeDivClass} id="resultArchiveTime">
                  <label className={classes.edgeWhiteLabel} style={dropdownHeaderStyle}>Archive Period</label>
                  <select
                    className={classes.edgeWhiteInput}
                    value={this.props.selectedTime}
                    onChange={this.updateSelectTime}
                  >
                    {this.getArchiveTimeForEDGE()}
                  </select>
                </div>
              </div>
            ) : (
              <div className={dropdownWrapperClass}>
                <Typography className={classes.dropdownHeader} style={dropdownHeaderStyle}>Archive Period</Typography>
                <FormControl className={resultFormControlClass} id="archiveTime">
                  <InputLabel classes={{ root: classes.whiteInputLabel }}>Archive Period</InputLabel>
                  <Select
                    value={this.props.selectedTime}
                    onChange={this.updateSelectTime}
                    input={
                      <Input
                        name="time"
                        id="time-helper"
                        classes={{ underline: classes.whiteUnderline, input: classes.whiteInput }}
                      />
                    }
                    classes={{ icon: classes.whiteIcon }}
                  >
                    {this.getArchiveTime()}
                  </Select>
                </FormControl>
              </div>
            )}

            {this.props.isEDGE ? (
              <div className={dropdownWrapperClass}>
                <Typography className={classes.dropdownHeader} style={dropdownHeaderStyle}>Your Session Link</Typography>
                <div className={edgeDivClass} id="resultLink">
                  <label className={classes.edgeWhiteLabel} style={{ display: 'block', marginBottom: '6px' }}>
                    Your Session Link
                  </label>
                  <input
                    id="textfieldLink"
                    type="text"
                    className={classes.edgeWhiteInput}
                    value={resultLink}
                    onChange={this.disableChanging.bind(this, resultLink)}
                  />
                  <Tooltip title="Copy link">
                    <IconButton className={classes.edgeWhiteIcon} onClick={this.copyToClipboard} aria-label="Copy">
                      <img src={copyIcon} alt="Copy" className={classes.iconImage} />
                    </IconButton>
                  </Tooltip>
                </div>
              </div>
            ) : (
              <div className={dropdownWrapperClass}>
                <Typography className={classes.dropdownHeader} style={dropdownHeaderStyle}>Your Session Link</Typography>
                <FormControl className={resultFormControlClass} id="link">
                  <TextField
                    id="textfieldLink"
                    label="Your session link"
                    value={resultLink}
                    onChange={this.disableChanging.bind(this, resultLink)}
                    InputLabelProps={{
                      shrink: true,
                      classes: { root: classes.whiteInputLabel }
                    }}
                    InputProps={{
                      classes: { underline: classes.whiteUnderline, input: classes.whiteInput },
                      endAdornment: (
                        <InputAdornment position="end">
                          <Tooltip title="Copy link">
                            <IconButton onClick={this.copyToClipboard} aria-label="Copy">
                              <img src={copyIcon} alt="Copy" className={classes.iconImage} />
                            </IconButton>
                          </Tooltip>
                        </InputAdornment>
                      )
                    }}
                  />
                </FormControl>
              </div>
            )}
          </div>
        </Grid>

        <div className={[classes.controlsRow, classes.mobileControlsRowStrip].join(' ')} />

        {showPrintModal && (
          <div className={classes.printModalBackdrop} onClick={this.closePrintModal}>
            <div className={classes.printModal} onClick={(e) => e.stopPropagation()}>
              <Typography variant="h6" className={classes.printModalTitle}>Select sections to print:</Typography>

              <label className={classes.printModalLabel}>
                <input
                  type="checkbox"
                  checked={printOverview}
                  onChange={(e) => this.setState({ printOverview: e.target.checked })}
                />
                Overview
              </label>

              <label className={classes.printModalLabel}>
                <input
                  type="checkbox"
                  checked={printLTP}
                  onChange={(e) => this.setState({ printLTP: e.target.checked })}
                />
                Long Term Projections
              </label>

              <label className={classes.printModalLabel}>
                <input
                  type="checkbox"
                  checked={printRec}
                  onChange={(e) => this.setState({ printRec: e.target.checked })}
                />
                Recommendation
              </label>

              <div className={classes.printModalButtons}>
                <Button onClick={this.closePrintModal} className={classes.printModalCancelButton}>Cancel</Button>
                <Button onClick={this.confirmPrint} className={classes.printModalPrintButton}>Print</Button>
              </div>
            </div>
          </div>
        )}

        <div className={panelsOuterClass}>
          <ExpansionPanel
            id="expansionPanel1"
            expanded={expanded === 'panel1' || expanded === 'all'}
            onChange={this.handleChange('panel1')}
            className={[expansionPanelBase, !printOverview && classes.printExclude].filter(Boolean).join(' ')}
          >
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon className={classes.expansionPanelSummary} />}>
              <Typography className={classes.heading}>Overview</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails className={classes.expansionDetails}>
              <div className={[classes.scrollableTable, classes.mobileScrollableTable].join(' ')}>
                <Table className={classes.tableOverview} id="overviewTable">
                  <TableHead>
                    <TableRow>
                      <CustomTableCell>Information</CustomTableCell>
                      <CustomTableCell numeric>Per Day</CustomTableCell>
                      <CustomTableCell numeric>Per Month</CustomTableCell>
                      <CustomTableCell numeric>Per Year</CustomTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow className={classes.row} key={0}>
                      <CustomTableCell className={classes.rowName} component="th" scope="row">Number of studies</CustomTableCell>
                      <CustomTableCell numeric>{this.getOverviewInformation("day", "studies")}</CustomTableCell>
                      <CustomTableCell numeric>{this.getOverviewInformation("month", "studies")}</CustomTableCell>
                      <CustomTableCell numeric>{this.getOverviewInformation("year", "studies")}</CustomTableCell>
                    </TableRow>
                    <TableRow className={classes.row} key={1}>
                      <CustomTableCell className={classes.rowName} component="th" scope="row">Storage for DICOM data in GB</CustomTableCell>
                      <CustomTableCell numeric>{this.getOverviewInformation("day", "storage")}</CustomTableCell>
                      <CustomTableCell numeric>{this.getOverviewInformation("month", "storage")}</CustomTableCell>
                      <CustomTableCell numeric>{this.getOverviewInformation("year", "storage")}</CustomTableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </div>

              <div className={[classes.devicesSummaryContainer, classes.mobileDevicesSummaryContainer].join(' ')}>
                <Typography className={classes.heading} style={{ marginBottom: '2.5rem', padding: '0 0 0 24px' }}>
                  Devices Summary
                </Typography>

                <div className={[classes.scrollableTable, classes.mobileScrollableTable].join(' ')}>
                  <Table className={classes.tableOverview} id="devicesSummaryTable">
                    <TableHead>
                      <TableRow>
                        <CustomTableCell>Device</CustomTableCell>
                        <CustomTableCell numeric>Quantity</CustomTableCell>
                        <CustomTableCell numeric>Studies per Day</CustomTableCell>
                        <CustomTableCell numeric>MB/Study</CustomTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {this.getDevicesSummaryRows()}
                    </TableBody>
                  </Table>
                </div>
              </div>

              <p className={classes.total}>Total Storage: {this.calculateTotalStorage()} TB</p>
            </ExpansionPanelDetails>
          </ExpansionPanel>

          <ExpansionPanel
            id="expansionPanel2"
            expanded={expanded === 'panel2' || expanded === 'all'}
            onChange={this.handleChange('panel2')}
            className={[expansionPanelBase, !printLTP && classes.printExclude].filter(Boolean).join(' ')}
          >
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon className={classes.expansionPanelSummary} />}>
              <Typography className={classes.heading}>Long Term Projections</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails className={classes.expansionDetails}>
              <div className={[classes.scrollableTable, classes.mobileScrollableTable].join(' ')}>
                <Table className={classes.longTermTable}>
                  <TableHead>
                    <TableRow>
                      <CustomTableCell>Year</CustomTableCell>
                      <CustomTableCell>DICOM Data in TB</CustomTableCell>
                      <CustomTableCell>Database Storage in GB</CustomTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.generateLongTermProjections().map((projection, index) => (
                      <TableRow key={index} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f0f0f0' }}>
                        <CustomTableCell>{projection.year}</CustomTableCell>
                        <CustomTableCell>{projection.dicomTB}</CustomTableCell>
                        <CustomTableCell>{projection.dbGB}</CustomTableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            </ExpansionPanelDetails>
          </ExpansionPanel>

          <ExpansionPanel
            id="expansionPanel3"
            expanded={expanded === 'panel3' || expanded === 'all'}
            onChange={this.handleChange('panel3')}
            className={[classes.resultExpansionPanel, !printRec && classes.printExclude, classes.mobileExpansionPanel].filter(Boolean).join(' ')}
          >
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon className={classes.expansionPanelSummary} />}>
              <Typography className={classes.heading}>Recommendation</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails className={classes.expansionDetails}>
              <div className={[classes.scrollableTable, classes.mobileScrollableTable].join(' ')}>
                <Table className={classes.recommendationTable}>
                  <TableHead>
                    <TableRow>
                      <CustomTableCell>Information</CustomTableCell>
                      <CustomTableCell>Value</CustomTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow className={classes.row} key={0}>
                      <CustomTableCell className={classes.rowName} component="th" scope="row">
                        Server Recommendation
                      </CustomTableCell>
                      <CustomTableCell>
                        {this.getRecommendation(this.props.server)}
                      </CustomTableCell>
                    </TableRow>
                    <TableRow className={classes.row} key={1}>
                      <CustomTableCell className={classes.rowName} component="th" scope="row">
                        Client Recommendation
                      </CustomTableCell>
                      <CustomTableCell>
                        {this.getRecommendation(this.props.client)}
                      </CustomTableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </div>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        </div>

        <Button
          className={[classes.printButton, classes.mobilePrintButton].join(' ')}
          onClick={this.printPage}
          id="printButton"
          aria-label="Print"
        >
          Print
        </Button>

        <Snackbar
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          open={this.state.showCopyNotification}
          message="Link Successfully Copied!"
          autoHideDuration={2000}
          onClose={() => this.setState({ showCopyNotification: false })}
          ContentProps={{ classes: { root: classes.snackbarContent } }}
        />

        <style>{`
          @media print {
            .printExclude { display: none !important; }
            #printButton { display: none !important; }
            #backButton, #nextButton { display: none !important; }
            .MuiExpansionPanelSummary-expandIcon { display: none !important; }
            .MuiExpansionPanel-root { box-shadow: none !important; }
            .scrollableTable { overflow: visible !important; }
            .stepBoxPrintHide { display: none !important; }
          }
        `}</style>
      </Grid>
    );
  }
}

Result.propTypes = {
  classes: PropTypes.object.isRequired,
  time: PropTypes.array.isRequired,
  selectedTime: PropTypes.string.isRequired,
  changeTime: PropTypes.func.isRequired,
  isEDGE: PropTypes.bool.isRequired,
  getSelectedDevices: PropTypes.array.isRequired,
  session: PropTypes.string.isRequired,
  server: PropTypes.string.isRequired,
  client: PropTypes.string.isRequired,
  changeActiveStep: PropTypes.func.isRequired,
  getSessionID: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  shareableLink: PropTypes.string.isRequired,
  updateShareableLink: PropTypes.func.isRequired,
};

Result.defaultProps = {
  time: [
    { id: 1, value: '1', text: '1 year' },
    { id: 2, value: '5', text: '5 years' },
    { id: 3, value: '10', text: '10 years' },
    { id: 4, value: '15', text: '15 years' },
    { id: 5, value: '20', text: '20 years' },
    { id: 6, value: '25', text: '25 years' },
  ],
  selectedTime: '1',
  changeTime: () => {},
  isEDGE: false,
  getSelectedDevices: [],
  session: '',
  server: 'server_M',
  client: 'client_min',
  changeActiveStep: () => {},
  getSessionID: () => {},
  match: { url: '' },
  shareableLink: '',
  updateShareableLink: () => {},
};

export default withStyles(mergedStyles)(Result);



// WEBPACK FOOTER //
// ./src/Result.js